export const PPT_GSV = 'PPT_GSV' //Visualizar botón de solicitud de ventas en presupuestador
export const PRESUPUESTO_AUTOMATIC_SAVE = 'PRESUPUESTO_AUTOMATIC_SAVE';
export const PRESUPUESTO_ULTIMO_EDITADO = 'PRESUPUESTO_ULTIMO_EDITADO';
export const PPT_ETP = "PPT_ETP";
export const PATENTE_LOCKED = 'La patente del usado entregado como parte de pago ya esta asociada a otra operación comercial'